export var trackApi = "https://assets.8891.com.tw/track/touch/c.8891.com.tw/config-track.json";
export var ignoreApiList = ["https://stats.g.doubleclick.net/j/collect", "https://securepubads.g.doubleclick.net/gampad/ads", "https://dc.8891.tw/api/generic", "https://securepubads.g.doubleclick.net/pcs/view", "https://c.8891.com.tw/api/v3/sales/popup", "https://securepubads.g.doubleclick.net/pagead/ppub_config", "https://www.google-analytics.com/j/collect"];
// 存储的API最大限制
export var TRACK_LOCAL_API_MAX_LENGTH = 100;
// localStorage 本地配置 key
export var TRACK_LOCAL_STORAGE_CONFIG_JSON = "__TRACK_LOCAL_STORAGE_CONFIG_JSON__";
// localStorage 本地API数据 key
export var TRACK_LOCAL_STORAGE_API_DATA = "__TRACK_LOCAL_STORAGE_API_DATA__";
// localStorage 本地点击spm值
export var TRACK_LOCAL_STORAGE_SPM = "__TRACK_LOCAL_STORAGE_SPM__";
// 支持直接页面取值的类型
export var TRACK_SUPPORT_PAGE_TYPE = ["self", "document", "pathname", "urlParams", "window"];